import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const fb_config = {
  apiKey: 'AIzaSyCM87Ll4_XTn_k_rrGrRTNoPQxIulfMtLU',
  authDomain: 'meny-stag.firebaseapp.com',
  projectId: 'meny-stag',
  storageBucket: 'meny-stag.appspot.com',
  messagingSenderId: '977714978420',
  appId: '1:977714978420:web:5130c6ce4677d4a63fbb21',
  measurementId: 'G-2S506DKC2M',
};

const app = firebase.initializeApp(fb_config);

export default app;
